/* eslint-disable no-console */

import useNotificationCounts from "../hooks/useNotificationsCount";
import "./provider-list.css";

const FirmsList = ({ firms, selectedFirm, onSelectFirm, loading, error }) => {
  const { allFirmCount } = useNotificationCounts();
  console.log(allFirmCount);

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#64748b" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            border: "3px solid #f1f5f9",
            borderTop: "3px solid var(--primary, #3b82f6)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 12px",
          }}
        />
        <p style={{ margin: 0, fontSize: "14px" }}>Loading organizations...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#ef4444" }}>
        <div style={{ fontSize: "24px", marginBottom: "8px" }}>⚠️</div>
        <p style={{ margin: 0, fontSize: "14px" }}>{error}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        flex: "1 1 0",
        minHeight: 0,
        overflow: "auto",
        scrollbarWidth: "none",
        "--chat-filler-row-height": "35px",
      }}
      className="chat-odd-even-color chat-sidebar-list"
    >
      {firms.map((firm) => {
        const firmUnreadCount = allFirmCount[firm.id];
        return (
          <div
            key={firm.id}
            onClick={() => {
              if (selectedFirm?.id !== firm.id) {
                onSelectFirm(firm);
              }
            }}
            className="onHoverChat"
            style={{
              // padding: "5px",
              // Same distance as the header tab labels from the window edge.
              paddingLeft: "8.5px",
              paddingRight: "8.5px",
              height: "35px",
              // borderBottom: "1px solid #f1f5f9",
              cursor: "pointer",
              // backgroundColor: selectedFirm?.id === firm.id ? "#f0f7ff" : "transparent",
              // borderRight:
              //   selectedFirm?.id === firm.id ? "3px solid var(--primary, #3b82f6)" : "none",
              transition: "all 0.2s ease",
            }}
            // onMouseEnter={(e) => {
            //   if (selectedFirm?.id !== firm.id) {
            //     e.target.style.backgroundColor = "#f8fafc";
            //   }
            // }}
            // onMouseLeave={(e) => {
            //   if (selectedFirm?.id !== firm.id) {
            //     e.target.style.backgroundColor = "transparent";
            //   }
            // }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                height: "35px",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: "29px",
                  height: "29px",
                  // borderRadius: "10px",
                  backgroundColor:
                    selectedFirm?.id === firm.id ? "var(--primary, #3b82f6)" : "#e2e8f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: selectedFirm?.id === firm.id ? "white" : "#64748b",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {firm.name.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    // marginBottom: "4px",
                    gap: "5px",
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: "600",
                      color: selectedFirm?.id === firm.id ? "var(--primary, #3b82f6)" : "#1e293b",
                    }}
                  >
                    {firm.name}
                  </h6>
                  {firmUnreadCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "-10px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        fontSize: "10px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      {firmUnreadCount}
                    </span>
                  )}
                </div>
                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    color: "#64748b",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {/* {firm.lastMessage || "No messages yet"} */}
                </p>
              </div>
            </div>
          </div>
        );
      })}
      <div className="chat-sidebar-filler" aria-hidden="true" />
    </div>
  );
};

export default FirmsList;
